import { render, staticRenderFns } from "./VanFieldSelectPicker.vue?vue&type=template&id=164a4e7a&scoped=true"
import script from "./VanFieldSelectPicker.vue?vue&type=script&lang=js"
export * from "./VanFieldSelectPicker.vue?vue&type=script&lang=js"
import style0 from "./VanFieldSelectPicker.vue?vue&type=style&index=0&id=164a4e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a4e7a",
  null
  
)

export default component.exports